import { Box, TextField, Typography } from '@mui/material';
import { Component, createRef } from 'react';
import AppManager from '../../commun/AppManager';
import { Spinner } from '../../commun/component/Spinner';
import { Color } from '../../commun/Constant';
import { post } from '../../commun/HTTP';
import Result from '../../commun/Result';
import Toast from '../../commun/toast/Toast';
import Category from '../../object/tag/Category';
import { getErrorMessage } from '../../utils/Error';
import MpModal, { IBaseModalProps } from '../extends/MpModal';
import { SelectColor } from '../SelectColor';
import { JSXInternal } from 'preact/src/jsx';
import { SelectCategoryList } from './SelectCategoryList';

export interface IFusionCategoryModalProps extends IBaseModalProps {
    category: Category;
    list: Category[];
}

export interface IFusionCategoryModalState {
    inCategory: Category | null;
    loading: boolean;
    error: string;
}

export default class FusionCategoryModal extends Component<IFusionCategoryModalProps, IFusionCategoryModalState> {
    inputRef: React.RefObject<HTMLInputElement>;

    constructor(props: IFusionCategoryModalProps) {
        super(props);

        this.state = this.initState();
        this.inputRef = createRef();
    }

    initState() {
        const p: IFusionCategoryModalState = {
            inCategory: null,
            loading: false,
            error: '',
        };
        return p;
    }

    componentDidUpdate(
        prevProps: Readonly<IFusionCategoryModalProps>,
        prevState: Readonly<IFusionCategoryModalState>,
        snapshot?: any,
    ): void {
        if (prevProps.open !== this.props.open) {
            this.setState(this.initState());
        }
        if (prevProps.open !== this.props.open && this.props.open) {
            setTimeout(() => {
                this.inputRef.current?.focus();
            });
        }
    }

    addVendor() {
        const { inCategory } = this.state;
        this.setState({
            loading: true,
            error: '',
        });
        if (inCategory !== null) {
            post('/category/update', {
                id_child_fussion: [this.props.category.getAjoIdentifier()],
                id_parent_fussion: inCategory.getAjoIdentifier(),
            }).then((res: any) => {
                this.setState({
                    loading: false,
                });
                if (Result.isSuccess(res)) {
                    Result.applyResult(res, AppManager.updater(), true);
                    this.props.onClose();
                    AppManager.addToast(new Toast('La catégorie a été fusionnée avec succès.', 'success'));
                } else {
                    this.setState({
                        error: getErrorMessage(Result.getErrorStr(res)),
                    });
                }
            });
        } else {
            this.setState({
                loading: false,
                error: 'Veuillez sélectionner une catégorie.',
            });
        }
    }

    render(): JSXInternal.Element {
        const { open, onClose } = this.props;
        const { loading, error, inCategory } = this.state;
        return (
            <MpModal
                open={open}
                onClose={onClose}
                onSubmit={() => {
                    this.addVendor();
                }}
                title={'Fusionner une catégorie'}
                done={'Fusionner'}
            >
                {loading ? (
                    <Box className="flex items-center justify-center py-12">
                        <Spinner color="blue" className="" />
                    </Box>
                ) : (
                    <Box className="flex flex-col !text-gray-600 gap-3">
                        <Typography className="!text-sm !font-semibold">FUSIONNER DANS</Typography>
                        <SelectCategoryList
                            list={this.props.list}
                            single={true}
                            selectList={inCategory !== null ? [inCategory] : []}
                            onSelectList={(l) => {
                                if (l.length > 0) {
                                    this.setState({
                                        inCategory: l[0],
                                    });
                                } else {
                                    this.setState({
                                        inCategory: null,
                                    });
                                }
                            }}
                        />
                        {error !== '' && (
                            <Typography
                                component={'p'}
                                className="!text-sm text-red-600 !mt-1 !mb-1 !font-medium text-center"
                            >
                                {error}
                            </Typography>
                        )}
                    </Box>
                )}
            </MpModal>
        );
    }
}
